import React from "react";

export default function MainTitle() {
  return (
    <div className="bg-black min-h-[80vh] text-white py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text Content */}
          <div className="space-y-8 text-left">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 via-yellow-200 to-gray-200">
              Invest in 24K Digital Gold & Silver
            </h1>
            <p className="text-xl sm:text-2xl text-gray-300">
              Start building your wealth with pure 24K Gold and Silver. Buy,
              sell, or save seamlessly — anytime, anywhere, with complete
              security.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <a
                href="https://play.google.com/store/apps/details?id=com.goldbee_app&hl=en_IN"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-transform duration-300 ease-in-out transform hover:scale-105 inline-block"
              >
                <img
                  src="/google-play-badge.png"
                  alt="Get it on Google Play"
                  className="h-14 w-auto object-contain"
                />
              </a>
              <a
                href="https://apps.apple.com/app/id/your.app.id"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-transform duration-300 ease-in-out transform hover:scale-105 inline-block"
              >
                <img
                  src="/app-store-badge.png"
                  alt="Download on the App Store"
                  className="h-14 w-auto object-contain"
                />
              </a>
            </div>
          </div>

          {/* Right Column - Gold & Silver Coins Display */}
          <div className="relative h-[600px] flex items-center justify-center">
            <div className="relative w-[400px] h-[400px] flex items-center justify-center animate-float">
              {/* Gold Coin */}
              <div className="absolute w-40 h-40 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-200 shadow-2xl border-4 border-yellow-500 flex items-center justify-center animate-spin-slow">
                <span className="text-black font-bold">24K</span>
              </div>
              {/* Silver Coin */}
              <div className="absolute w-32 h-32 rounded-full bg-gradient-to-br from-gray-300 to-gray-100 shadow-xl border-4 border-gray-400 flex items-center justify-center animate-spin-slow [animation-duration:20s] translate-x-32 translate-y-20">
                <span className="text-black font-bold">Ag</span>
              </div>
            </div>

            {/* Background Glows */}
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-yellow-400/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
            <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-gray-300/20 rounded-full mix-blend-multiply filter blur-3xl animate-blob2"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
